export enum VideoJsHlsEvents {
  RetryPlaylist = 'retryplaylist'
}
